import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue';
import ReceiptPageHeadPreloader from '../receipt-page-head-preloader/receipt-page-head-preloader.vue';
import { IconWrapper } from 'ui-shared-components';

type Props = {
  title?: string
  subtitle?: string
  contentLoading?: boolean
  noContainer?: boolean
  isCancelled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'receipt-info-header',
  props: {
    title: { default: '' },
    subtitle: { default: '' },
    contentLoading: { type: Boolean, default: false },
    noContainer: { type: Boolean, default: false },
    isCancelled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { title: string, subtitle: string, contentLoading: boolean, noContainer: boolean, isCancelled: boolean };

const IconCheck = () => import('@white-label-icon/icon-check')



const instance = getCurrentInstance();
const proxy = instance?.proxy as Vue;

const headerText = computed(() => {
  if (props.isCancelled) {
    return proxy.$t('manageBooking.menu.myBooking');
  }
  return proxy.$t('receipt.bookingConfirmed')
})

return { __sfc: true,IconCheck, props, instance, proxy, headerText, ReceiptPageHeadPreloader, IconWrapper }
}

})